import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
export interface Element {
  SessionYear: string;
  SessionName: string;
  AdmissionStatus: string;
  SessionStatus: string;
  Action: string;

}

const ELEMENT_DATA: Element[] = [
  {SessionYear: 'ind', SessionName: 'Afghanistan',  AdmissionStatus: 'y', SessionStatus: 'y', Action: ''},
  {SessionYear: 'ind', SessionName: 'pakistan',  AdmissionStatus: 'n', SessionStatus: 'n', Action: ''},
  {SessionYear: 'usa', SessionName: 'france',  AdmissionStatus: 'y', SessionStatus: 'y', Action: ''},
  {SessionYear: 'uk', SessionName: 'itly',  AdmissionStatus: 'n', SessionStatus: 'y', Action: ''},
  {SessionYear: 'jk', SessionName: 'iran',  AdmissionStatus: 'y', SessionStatus: 'y', Action: ''},


];
@Component({
  selector: 'app-academic-session-master',
  templateUrl: './academic-session-master.component.html',
  styleUrls: ['./academic-session-master.component.scss']
})
export class AcademicSessionMasterComponent implements OnInit {
  displayedColumns = ['SessionYear', 'SessionName', 'AdmissionStatus', ' SessionStatus', 'Action'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  @ViewChild(MatSort) sort: MatSort;
  constructor() { }

  ngOnInit(): void {
  }
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

}
